define(function(require, exports, module) {
    var $ = require('jquery');
    var toolkit = require('toolkit/b-toolkit/b-toolkit');
    require('ajs/__lang/ajs__lang');

    var settings = require('Cloud/settings');

    if (settings.lang) {
        Lang.add({ RU: settings.lang });

        {
            // CLOUDWEB-6240
            // toolkit использует несовместимый с ajs формат словаря.
            // Так как оба формата словарей являются устаревшими и в будущем
            // планируется перейти на новую схему i18n, сейчас переопределим
            // метод toolkit.lang.get следующим образом:
            var lang = toolkit.lang;
            var langGet = lang.get;

            lang.get = function(key) {
                // Cloud/Lang.js: toolkit.lang.get is overridden!
                return Lang.get(key) || langGet.call(lang, key);
            };

            /*
             * Следующий код добавляет в свойство __proto__
             * объекта patron.toolkit.lang ссылку на объект lang
             * с переводами для Cloud
             * */
            var fixedLang = Object.create(settings.lang);
            Object.keys(Lang).forEach(function(key) {
                fixedLang[key] = Lang[key];
            });

            Lang = fixedLang;
        }
    }

    Lang.add({
        RU: {
            Date: {
                months: [
                    ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
                    ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
                    ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
                ],
                weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
                weekdays_full: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],

                format: { full: 'd n Y в H:I' },
                today: 'сегодня',
                yesterday: 'вчера',
            },
        },
    });

    if (typeof patron !== 'undefined') {
        patron.toolkit.lang = patron.toolkit.lang || {};

        patron.toolkit.lang.datetime = {
            months: {
                short: ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
            },
        };
    }

    module.exports = {
        getLang: function() {
            return Lang;
        },
    };
});
